import { render, staticRenderFns } from "./LangsComponent.vue?vue&type=template&id=1e6ec439&scoped=true&"
import script from "./LangsComponent.vue?vue&type=script&lang=js&"
export * from "./LangsComponent.vue?vue&type=script&lang=js&"
import style0 from "./LangsComponent.vue?vue&type=style&index=0&id=1e6ec439&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ec439",
  null
  
)

export default component.exports